export const TEAM_PERMISSION_KEYS = ['manageBusiness', 'manageFeed', 'manageNudge', 'manageTeam'];

export const TEAM_PERMISSION_OPTIONS = [
  { key: 'manageBusiness', label: 'Manage Business' },
  { key: 'manageFeed', label: 'Manage Feed' },
  { key: 'manageNudge', label: 'Manage Nudge' },
  { key: 'manageTeam', label: 'Manage Team' },
];

export const DEFAULT_TEAM_PERMISSIONS = {
  manageBusiness: false,
  manageFeed: false,
  manageNudge: false,
  manageTeam: false,
};

export const TEAM_PERMISSION_DENIED_MESSAGE =
  'You do not have permission to perform this action.';

export const CREATE_POST_PERMISSION_MESSAGE = "You don't have permission to create a post";

export const CREATE_NUDGE_PERMISSION_MESSAGE = "You don't have permission to create a nudge";

export const areTeamPermissionsEqual = (left = {}, right = {}) =>
  TEAM_PERMISSION_KEYS.every((key) => Boolean(left[key]) === Boolean(right[key]));
